import { BCDataGrid } from '@bimser/components';
import DataGrid2 from '../..';
import { IDataLoadEventArgs } from '../../../../entities/EventArgs';
import { makeReq, makeUrl } from './utils';

export const createSelfCustomStore = (dataGrid: DataGrid2) => {
	return new BCDataGrid.Components.CustomStore({
		key: dataGrid.getUniqueDataField(),
		load: async _loadOptions => {
			if (dataGrid.__form.displayMode !== 'execution') {
				return {
					data: [],
					totalCount: 0
				};
			}

			const columns = dataGrid.__bcDataGridRef.current
				.instance()
				.option('columns') as BCDataGrid.Entities.IRemoteColumnProps[];
			const loadOptions = BCDataGrid.Helpers.convertLoadOptions(_loadOptions, columns);

			const response = await makeReq<any>(makeUrl(dataGrid, 'getRows'), {
				documentId: dataGrid.__form.documentId,
				controlName: dataGrid.name,
				columns: dataGrid.columns,
				loadOptions
			});

			const data = response.data.rows.map(row => row.data);

			await dataGrid.emit('event:OnDataLoad', { data } as IDataLoadEventArgs);

			await dataGrid.set('rows', response.data.rows);

			return {
				data,
				totalCount: response.data.count
			};
		},
		update: async (key, data) => {
			if (dataGrid.__form.displayMode !== 'execution') {
				return;
			}

			const keyExpr = dataGrid.getUniqueDataField();
			const oldRow = dataGrid.rows.find(row => row.data[keyExpr] === key);
			const row = dataGrid.newRow({ ...oldRow, data: { ...oldRow.data, ...data } });

			await makeReq(makeUrl(dataGrid, 'UpdateRow'), {
				documentId: dataGrid.__form.documentId,
				controlName: dataGrid.name,
				columns: dataGrid.columns,
				row
			});
		},
		remove: async key => {
			if (dataGrid.__form.displayMode !== 'execution') {
				return;
			}

			const keyExpr = dataGrid.getUniqueDataField();
			const row = dataGrid.rows.find(row => row.data[keyExpr] === key);

			await makeReq(makeUrl(dataGrid, 'DeleteRows'), {
				documentId: dataGrid.__form.documentId,
				controlName: dataGrid.name,
				rowIds: [row.rowId]
			});
		},
		insert: async data => {
			if (dataGrid.__form.displayMode !== 'execution') {
				return;
			}

			const row = dataGrid.newRow({ data });

			await makeReq(makeUrl(dataGrid, 'InsertRows'), {
				documentId: dataGrid.__form.documentId,
				controlName: dataGrid.name,
				columns: dataGrid.columns,
				rows: [row]
			});
		}
	});
};
